import { render } from "./OlabMedia.vue?vue&type=template&id=6e81fd50&scoped=true"
import script from "./OlabMedia.vue?vue&type=script&lang=js"
export * from "./OlabMedia.vue?vue&type=script&lang=js"

import "./OlabMedia.vue?vue&type=style&index=0&id=6e81fd50&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e81fd50"]])

export default __exports__